module.exports = __webpack_public_path__ + "img/b3_bingchuanzhixi.5451d51e.jpg";